/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum representing files extensions/types supported by the report export endpoint.
 */
export const ExportFileFormat = {
    Csv: 1,
    Xls: 2,
    Zip: 3,
    Xlsx: 4
} as const;
export type ExportFileFormat = typeof ExportFileFormat[keyof typeof ExportFileFormat];

